import { render, staticRenderFns } from "./ALLConfigurator.vue?vue&type=template&id=7963158c"
import script from "./ALLConfigurator.vue?vue&type=script&lang=ts"
export * from "./ALLConfigurator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports